import styled from 'styled-components';

const SubHeading = styled.h3`
    margin: 100px auto 30px auto;
    font-size: 1.2rem;
    font-weight: 800;
    color: ${p => p.theme.primaryColor};
    text-align: center;
    letter-spacing: 1px;
`;

export default SubHeading;
